import FormGroup from "legacy/FormGroup"
import {
  arrayToSentence,
  centsToDollarsRaw,
  handleInputChange,
  isPresent,
  safePercentageDecimal,
  snakeCaseToReadable,
} from "legacy/helpers.es6"
import CustomizeBillingForm from "legacy/manage/CustomizeBillingForm"
import FeesAndDiscountsForm from "legacy/manage/FeesAndDiscountsForm"
import { validatorFactory } from "legacy/validatorFactory"
import _ from "lodash"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class RateModal extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showModal: false,
      isCustomBillingSet: this.props.isCustomBillingSet,
      isRateApplied: this.props.isRateApplied,
      customBilling: {
        ...this.props.customBilling,
        customBillingPeriod: !!(
          this.props.customBilling.billingStartDate ||
          this.props.customBilling.billingEndDate
        ),
      },
      rate: {
        ...this.props.rate,
        feesAndDiscounts: this.props.rate.feesAndDiscounts || [],
      },
      contractType: this.props.rate.monthToMonth
        ? "month_to_month"
        : "standard",
      billingCycles: this.props.rateOptions.billingCycles,
      feeCategories: this.props.rateOptions.feeCategories,
      pricingStructures: this.props.rateOptions.pricingStructures,
      namedRates: this.props.rateOptions.namedRates,
      rateType: this.props.rateType,
    }
    this.validator = validatorFactory()

    this.launchModal = this.launchModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.updateCustomRate = this.updateCustomRate.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleRateInputChange = this.handleRateInputChange.bind(this)
    this.handleCustomBillingInputChange =
      this.handleCustomBillingInputChange.bind(this)
    this.updateFeesAndDiscounts = this.updateFeesAndDiscounts.bind(this)
    this.handleContractTypeChange = this.handleContractTypeChange.bind(this)
  }

  componentDidMount() {
    this.handleContractTypeChange(this.state.contractType)
  }

  handleInputChange(event) {
    handleInputChange(this, event)
  }

  handleRateInputChange(event) {
    const target = event.target
    const value = target.type === "checkbox" ? target.checked : target.value
    const names = target.name.split(".")

    // the cust billing form we are using refers to rate not amount
    if (names[0] === "rate") {
      this.setState({ rate: { ...this.state.rate, amount: value } })
    } else {
      this.setState({ rate: { ...this.state.rate, [names[0]]: value } })
    }
  }

  handleCustomBillingInputChange(event) {
    const target = event.target
    const value = target.type === "checkbox" ? target.checked : target.value
    const names = target.name.split(".")
    this.setState({
      customBilling: { ...this.state.customBilling, [names[0]]: value },
    })
  }

  updateFeesAndDiscounts(newFeesAndDiscounts) {
    this.setState({
      rate: { ...this.state.rate, feesAndDiscounts: newFeesAndDiscounts },
    })
  }

  updateBillingDates(date, key) {
    this.setState({
      customBilling: {
        ...this.state.customBilling,
        [key]: moment(date).format("YYYY-MM-DD"),
      },
    })
  }

  handleContractTypeChange(contractType) {
    const newState = {
      contractType,
      rate: {
        ...this.state.rate,
        monthToMonth: contractType === "month_to_month",
      },
    }
    if (contractType === "month_to_month") {
      newState.pricingStructures = {
        monthly: this.props.rateOptions.pricingStructures.monthly,
      }
      newState.billingCycles = _.filter(
        this.state.billingCycles,
        (cycle) => cycle === "first_of_month"
      )
      newState.rate.billingCycle = "first_of_month"
    } else {
      newState.pricingStructures = this.props.rateOptions.pricingStructures
      newState.billingCycles = this.props.rateOptions.billingCycles
      newState.rate.billingCycle =
        this.props.rate.billing_cycle || this.props.rateOptions.billingCycles[0]
    }
    this.setState(newState)
  }

  launchModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false })
  }

  updateCustomRate() {
    if (this.validator.allValid()) {
      this.setState({ isCustomBillingSet: true })
      if (
        this.state.rate.billingCycle === "first_of_month" &&
        !$context.hasCustomInstallmentFeature
      ) {
        this.setState({
          customBilling: {
            ...this.state.customBilling,
            billingStartDate: null,
            billingEndDate: null,
          },
        })
      }
      this.closeModal()
      this.updateParent()
    } else {
      this.validator.showMessages()
      this.forceUpdate()
    }
  }

  billingCycleText() {
    const textForBillingCycles = {
      upfront: "Billed upfront",
      first_of_month: "Billed on the 1st of each month",
      half_and_half: "Billed in two installments",
    }
    return textForBillingCycles[this.state.rate.billingCycle]
  }

  feesAndDiscountsText() {
    if (!this.state.rate.feesAndDiscounts.length) {
      return null
    }
    const categoryDisplayNames = {
      electric: "Electric",
      fee: "Marina Service Fees",
      discount: "Discounts",
    }
    const text = "Including: "
    const categories = _.uniq(
      _.map(
        this.state.rate.feesAndDiscounts,
        (obj) => categoryDisplayNames[obj.category]
      )
    )
    return text + arrayToSentence(categories)
  }

  pricingStructureText() {
    const keys = _.flatten(_.values(this.props.rateOptions.pricingStructures))
    const option = _.find(keys, ["value", this.state.rate.pricingStructure])
    return snakeCaseToReadable(option.name)
  }

  customRateAdded() {
    if (this.state.isCustomBillingSet && this.state.rate.amount) {
      return (
        <div>
          <div className="alert alert-info rounded" role="alert">
            <p className="font-semibold">Custom Rate Added</p>
            <p>
              ${this.state.rate.amount} {this.pricingStructureText()}
            </p>
            <p>{this.billingCycleText()}</p>
            <p>{this.feesAndDiscountsText()}</p>
          </div>
        </div>
      )
    }
    return null
  }

  getStartDate() {
    if (
      $('input[name="check_in_date"]').length &&
      isPresent($('input[name="check_in_date"]').val())
    ) {
      return moment($('input[name="check_in_date"]').val(), "MM/DD/YYYY")
    }
    return null
  }

  getEndDate() {
    if (
      $('input[name="check_out_date"]').length &&
      isPresent($('input[name="check_out_date"]').val())
    ) {
      return moment($('input[name="check_out_date"]').val(), "MM/DD/YYYY")
    }
    return null
  }

  changeRateType(value) {
    const namedRate = _.find(
      this.props.rateOptions.namedRates,
      (rate) => rate.id.toString() === value
    )
    let newState = {}
    if (namedRate) {
      newState = {
        rateType: value,
        isRateApplied: true,
        isCustomBillingSet: false,
        rate: {
          ...namedRate,
          amount: namedRate.amount ? centsToDollarsRaw(namedRate.amount) : 0,
          taxRate: namedRate.taxRate
            ? safePercentageDecimal(namedRate.taxRate)
            : 0.0,
          feesAndDiscounts: namedRate.feesAndDiscounts || [],
        },
      }
    } else if (value === "nightly") {
      newState = {
        rateType: value,
        isRateApplied: false,
        isCustomBillingSet: false,
        rate: {
          id: null,
          name: null,
          pricingStructure: "per_month",
          billingCycle: "first_of_month",
          amount: 0,
          taxRate: 0.0,
          feesAndDiscounts: [],
        },
      }
    } else {
      newState = {
        rateType: value,
        isRateApplied: false,
        isCustomBillingSet: true,
        rate: {
          id: null,
          name: null,
          pricingStructure: "per_month",
          billingCycle: "first_of_month",
          amount: 0,
          taxRate: 0.0,
          feesAndDiscounts: [],
        },
      }
    }

    this.setState(newState)
    this.props.updateParentState(newState)
  }

  updateParent() {
    this.props.updateParentState({
      rate: this.state.rate,
      customBilling: {
        billingStartDate: this.state.customBilling.billingStartDate,
        billingEndDate: this.state.customBilling.billingEndDate,
      },
      isRateApplied: this.state.isRateApplied,
      isCustomBillingSet: this.state.isCustomBillingSet,
    })
  }

  installmentRateOptions() {
    if (this.props.rateOptions.namedRates.length === 0) return null

    return (
      <optgroup label="Installment Rates">
        {_.map(this.props.rateOptions.namedRates, (rate) => (
          <option key={rate.id} value={rate.id}>
            {rate.name}
          </option>
        ))}
      </optgroup>
    )
  }

  render() {
    return (
      <div>
        <FormGroup
          inputType="select"
          value={this.state.rateType}
          name="rateType"
          onChange={(event) => {
            this.changeRateType(event.target.value)
          }}
        >
          <optgroup label="Default Nightly Rates">
            <option key="nightly" value="nightly">
              Default rates
            </option>
          </optgroup>
          {this.installmentRateOptions()}
          <optgroup label="Custom Rate">
            <option key="custom_installment" value="custom_installment">
              Enter a custom rate
            </option>
          </optgroup>
        </FormGroup>

        {this.state.rateType === "custom_installment" && (
          <button
            className="btn btn-secondary mb-2"
            onClick={this.launchModal}
            type="button"
          >
            {this.state.isCustomBillingSet && this.state.rate.amount
              ? "Edit Custom Rate"
              : "Add Custom Rate"}
          </button>
        )}
        {this.customRateAdded()}
        <Modal
          isOpen={this.state.showModal}
          onClose={this.closeModal}
          size="mediumFixed"
        >
          <Modal.Header title="Custom Rate" />
          <Modal.Body>
            <div className="row">
              <div className="col-sm-3">
                <h4>General</h4>
              </div>
              <div className="col-sm-9">
                <FormGroup
                  inputType="select"
                  label="Billing Type"
                  name="contractType"
                  value={this.state.contractType}
                  onChange={(event) =>
                    this.handleContractTypeChange(event.target.value)
                  }
                >
                  <option key="standard" value="standard">
                    Standard
                  </option>
                  <option key="month_to_month" value="month_to_month">
                    Month to month
                  </option>
                </FormGroup>
              </div>
            </div>
            <hr />
            <CustomizeBillingForm
              validator={this.validator}
              rate={this.state.rate.amount}
              taxRate={this.state.rate.taxRate}
              billingCycle={this.state.rate.billingCycle}
              pricingStructure={this.state.rate.pricingStructure}
              billingCycles={this.state.billingCycles}
              pricingStructures={this.state.pricingStructures}
              customBillingPeriod={this.state.customBilling.customBillingPeriod}
              billingStartDate={this.state.customBilling.billingStartDate}
              billingEndDate={this.state.customBilling.billingEndDate}
              hideDirectPaymentOption
              handleInputChange={this.handleRateInputChange}
              handleCustomBillingInputChange={
                this.handleCustomBillingInputChange
              }
              setBillingDateState={(date, key) =>
                this.updateBillingDates(date, key)
              }
              editMode={false}
              hasCustomInstallmentFeature={$context.hasCustomInstallmentFeature}
            />
            <hr />
            <FeesAndDiscountsForm
              updateFeesAndDiscounts={this.updateFeesAndDiscounts}
              feesAndDiscounts={this.state.rate.feesAndDiscounts}
              feeCategories={this.state.feeCategories}
              pricingStructure={this.state.rate.pricingStructure}
              startDate={this.getStartDate()}
              endDate={this.getEndDate()}
              hideLengthOfFeeOption={true}
            />
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Cancel"
            confirmBtnText="Save"
            onClose={this.closeModal}
            onSubmit={this.updateCustomRate}
          />
        </Modal>
      </div>
    )
  }
}

RateModal.propTypes = {
  isCustomBillingSet: PropTypes.bool,
  isRateApplied: PropTypes.bool,
  customBilling: PropTypes.shape({
    billingStartDate: PropTypes.string,
    billingEndDate: PropTypes.string,
  }),
  rate: PropTypes.shape({
    monthToMonth: PropTypes.bool,
    billing_cycle: PropTypes.string,
    feesAndDiscounts: PropTypes.array,
  }),
  rateType: PropTypes.string,
  rateOptions: PropTypes.shape({
    billingCycles: PropTypes.array.isRequired,
    feeCategories: PropTypes.array.isRequired,
    pricingStructures: PropTypes.object.isRequired,
    namedRates: PropTypes.array.isRequired,
  }).isRequired,
  updateParentState: PropTypes.func.isRequired,
}

export default RateModal
